import React from 'react';
import { Route } from 'react-router-dom';
import Subscription from '../../Payment-Users/Dashboard-subscription.js';
import SubscriptionPlans from '../../Payment-Users/viewsubscriptionplan.js';
import AddOnPlans from '../../Payment-Users/view-addonplans.js';
import Paymentdetails1 from '../../Payment-Users/Paymentdetails1.js';
import Paymentdetails2 from '../../Payment-Users/Paymentdetails2.js';
import PaymentStatistics from '../../Payment-Users/PaymentStatistics.js';

export const paymentRoutes = [
  <Route key="subscription" path="/subscription" element={<Subscription />} />,
  <Route key="plans" path="/Plans" element={<SubscriptionPlans />} />,
  <Route key="addon-plans" path="/AddOnPlans" element={<AddOnPlans />} />,
  <Route key="payments" path="/Payments" element={<Paymentdetails1 />} />,
  <Route key="user-payments" path="/user-payments/:email" element={<Paymentdetails2 />} />,
  <Route key="payment-statistics" path="/payment-statistics" element={<PaymentStatistics />} />,
];
